import type { UIMessageWithDataTypes } from "@/types/chat-parts";

export const EMPTY_MESSAGES: UIMessageWithDataTypes[] = [];
